import React, { useState } from 'react'
import { v4 as uuid } from 'uuid'
import { isEmpty, isNil } from 'lodash'
import { IconMinus, IconPlus } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { Card } from '@/components/cards/Card'
import { CopyButton } from '@/components/buttons/CopyButton'
import { formatDuration } from '@/utils/helpers'
import { ExternalLink } from '@/components/ExternalLink'
import { PoweredByAI } from '@/components/ai/PoweredByAI'

export const Evidence = ({ call, dynsight_session_id }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleSummary = () => {
    setExpanded(!expanded)
  }
  const isMessageEvidence = !isNil(call.message_id)
  const label = isMessageEvidence ? 'Message' : 'Call'
  const evidenceLink = isMessageEvidence
    ? `/messages/${call.message_id}?dynsight_session_id=${dynsight_session_id}`
    : `/calls/${call.call_id}?dynsight_session_id=${dynsight_session_id}`
  return (
    <Card key={call.call_id} className="mb" data-testid="evidence-component">
      <h3 className="flex-align-start gap">
        {call.explanation}
        <ExternalLink
          to={evidenceLink}
          label={`View ${label}`}
          className="balto-button default small no-wrap"
          target="_blank"
        />
      </h3>
      <div className="muted-text">
        <PoweredByAI />
      </div>
      {expanded ? (
        <p data-testid="call-summary-full">{call.summary}</p>
      ) : (
        <p data-testid="call-summary-partial" className="truncated">
          {call.summary}
        </p>
      )}
      <div className="flex-align-center small-gap mb">
        <Button small onClick={toggleSummary} data-testid="expand-collapse-button">
          {expanded ? <IconMinus /> : <IconPlus />}
          {expanded ? 'Collapse' : 'Expand'} Summary
        </Button>
        <CopyButton name="Summary" content={`${call.explanation} \n\n ${call.summary}`} />
      </div>
      {!isEmpty(call.excerpts) && <h4 data-testid="call-excerpts-header">{label} Excerpts</h4>}
      <ul>
        {call.excerpts.map((excerpt) => {
          return (
            <li key={uuid()}>
              {`${excerpt.text} `}
              {excerpt.timestamp != null && !isMessageEvidence && (
                <ExternalLink
                  to={`/calls/${call.call_id}?timestamp=${excerpt.timestamp}&dynsight_session_id=${dynsight_session_id}`}
                  label={`[${formatDuration(excerpt.timestamp)}]`}
                  target="_blank"
                />
              )}
            </li>
          )
        })}
      </ul>
    </Card>
  )
}
